import { useEffect, useState } from 'react';

export function useIsNotTouchDevice(onTouchDeviceDetected?: () => void) {
  const [isNotTouchDevice, setIsNotTouchDevice] = useState<boolean | undefined>(undefined);

  useEffect(() => {
    if (typeof window === 'undefined' || !('matchMedia' in window)) return;

    const mediaQuery = window.matchMedia('(hover: hover) and (pointer: fine)');
    const isTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;

    const update = () => {
      const matches = mediaQuery.matches;
      setIsNotTouchDevice(matches);

      if ((!matches || isTouch) && typeof onTouchDeviceDetected === 'function') {
        setTimeout(() => {
          onTouchDeviceDetected();
        }, 0);
      }
    };

    update();

    if ('addEventListener' in mediaQuery) {
      mediaQuery.addEventListener('change', update);
      return () => mediaQuery.removeEventListener('change', update);
    }
  }, [onTouchDeviceDetected]);

  return isNotTouchDevice;
}
